function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.408 11.04c-3.14 0-5.82 1.897-6.858 4.565-8.917-1.71-14.59 3.145-15.39 9.204-4.85 0-9.042 2.907-8.78 8.427C2.003 46.3 21.69 47.53 28.313 47.568c12.072-.095 25.652-3.701 26.638-14.05 0-3.22-2.257-5.932-5.335-6.762 1.246-6.16-1.967-11.875-10.203-10.747-.915-2.878-3.706-4.969-7.003-4.969z",
  fill: "none",
  stroke: "var(--primary-color, #000)"
});

var SvgCloud = function SvgCloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cloud.5bbb8425.svg";
export { ForwardRef as ReactComponent };